module.exports = __webpack_public_path__ + "static/media/ib_elyakada_logo.d640a8ca.png";